export default "__VITE_ASSET__avQBO6wm__"